import { IDs } from './IDs';

export function disableKosten(data: any): boolean {
    return (
        ((data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig === 'kommunalverwaltung' &&
        ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).kosten_erfassen_orig !== 1 // {1} Ja
    );
}

export function showKostenKonfiguration(data: any): boolean {
    return ((data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig === 'kommunalverwaltung';
}
